// extracted by mini-css-extract-plugin
module.exports = {"layout":"jx","content":"jy","a":"jz","footer":"jA"};